
// export type Reaction = {
//     type        : number,
//     value       : string,
//     name?       : string
// }

export type ReactionsGroup = {
    reactions   : number[]  // reaction TYPE ID
    name        : string
}

// Deprecated -> use emoji lib
export const ALL_REACTIONS : NumberDictionary = {


    // reactions
    // 1       : "✅",
    // 2       : "👀",
    // 3       : "",
    // 4       : "🔥",
    // 5       : "❤",
    // 6       : "",

    // Gestures
    20          : "👍",
    21          : "👎",
    22          : "👏",
    23          : "🤝",
    24          : "👋",
    25          : "🤟",
    26          : "✌️",
    27          : "👆",
    28          : "👇",
    29          : "🖕",
    30          : "☝️",
    31          : "🙏",
    32          : "🤛",
    33          : "🤜",
    34          : "💪",
    35          : "🙌",
    36          : "🤷",
    37          : "🤷‍♀️",
    38          : "🤦",
    39          : "🤦‍♀️",


    // Smiles / Mood
    50          : "🙂",
    51          : "😀",
    52          : "😅",
    53          : "😂",
    54          : "😎",
    55          : "😝",
    56          : "🤪",
    57          : "😇",
    58          : "🤔",
    59          : "😬",
    60          : "😋",
    61          : "😜",
    62          : "😌",
    63          : "😊",
    64          : "😍",
    65          : "🥰",
    66          : "😘",
    67          : "😢",
    68          : "😓",
    69          : "😨",
    70          : "😱",
    71          : "😕",
    72          : "😡",
    73          : "🤬",
    74          : "🤢",
    75          : "🤮",
    76          : "😱",
    77          : "🤓",
    78          : "🤑",
    79          : "😈",
    80          : "🤡",
    81          : "💩",
    82          : "👻",
    83          : "💀",
    84          : "👽",
    85          : "🎃",
    86          : "😺",
    87          : "😹",
    88          : "😻",
    89          : "😽",
    90          : "🙀",
    91          : "😿",
    92          : "😾",


    // Numbers
    100       : "0️⃣️",
    101       : "1️⃣",
    102       : "2️⃣",
    103       : "3️⃣",
    104       : "4️⃣️",
    105       : "5️⃣️",
    106       : "6️⃣",
    107       : "7️⃣",
    108       : "8️⃣",
    109       : "9️⃣",
    110       : "🔟",

    // Symbols
    200         : "❤️",
    201         : "🛑",
    202         : "⛔️",
    203         : "🚫",
    204         : "💯",
    205         : "✅️",
    206         : "❎",
    207         : "🔺",
    208         : "🔻",
    209         : "❗️",
    210         : "❓",
    215         : "🔄",
    224         : "⚠️",
    216         : "🆘",

    // Objects
    227         : "🏆",
    228         : "🥇",
    229         : "🥈",
    230         : "🥉",
    231         : "📌",
    225         : "🔍️",
    226         : "💡",
    232         : "📎",
    221         : "🔔",
    222         : "🖨️",
    223         : "🔒",
    217         : "🚀",
    218         : "🎯",
    219         : "🏁",
    211         : "📣",
    212         : "⏰",
    213         : "⏳",
    214         : "🗓",
    220         : "👀",
    233         : "🔥",
    234         : "🕑",
    235         : "⭐",
    236         : "🎉",
    237         : "🌐"

}

export const REACTIONS_GESTURES :ReactionsGroup = {
    name        : 'Gestures',
    reactions   : [
        20,21,22,23,24,25,26,27,28,29,30,31,
        32,33,34,35,36,37,38,39
    ]
}

export const REACTIONS_SMILES :ReactionsGroup = {
    name        : 'Smiles',
    reactions   : [
        50, 51,52,53,54,55,56,57,58,59,
        60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,
        80,81,82,83,84,85,86,87,88,89,90,91,92
    ]
}

export const REACTIONS_OBJECTS :ReactionsGroup = {
    name        : 'Objects',
    reactions   : [
        227, 228 , 229 , 230 , 231 , 225 , 226 , 232 , 221 , 222 , 223 , 217 , 218 , 219 , 211 , 212 , 213 , 214 ,
        220 , 233 , 234 , 235, 236, 237
    ]
}

export const REACTIONS_SYMBOLS :ReactionsGroup = {
    name        : 'Symbols',
    reactions   : [
        200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 215, 224, 216
    ]
}

export const REACTIONS_NUMBERS :ReactionsGroup = {
    name        : 'Numbers',
    reactions   : [
        100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110
    ]
}

// {type: 61, value: "💡"},
// {type: 59, value: "⚠️"},


